import React from 'react';
import { Link } from 'react-router-dom';
import GridOverlay from './GridOverlay';

export const CtaBand = ({
    eyebrow = 'Manufacturer Direct',
    title = 'Generate Your Field Spec Report',
    body,
    cta = { to: '/quote', label: 'Get a Manufacturer Direct Quote' },
    secondary,
}) => (
    <section
        className="relative overflow-hidden border-y border-brand-hairline bg-brand-surface"
        data-testid="cta-band"
    >
        <GridOverlay size={56} opacity={0.16} />
        <div className="relative z-10 mx-auto flex max-w-7xl flex-col gap-8 px-6 py-16 md:flex-row md:items-end md:justify-between md:px-10 md:py-24">
            <div className="max-w-2xl">
                <span className="eyebrow">{eyebrow}</span>
                <h2 className="h-display mt-6 text-3xl sm:text-4xl">{title}</h2>
                {body ? (
                    <p className="mt-5 font-sans text-base text-brand-muted">{body}</p>
                ) : null}
            </div>
            <div className="flex flex-wrap gap-3 md:shrink-0">
                {secondary ? (
                    <Link
                        to={secondary.to}
                        data-testid="cta-band-secondary"
                        className="border border-brand-hairline px-5 py-3 font-display text-xs font-bold uppercase tracking-[0.16em] text-brand-text transition-colors duration-150 hover:border-brand-gold hover:text-brand-gold"
                    >
                        {secondary.label}
                    </Link>
                ) : null}
                <Link
                    to={cta.to}
                    data-testid="cta-band-primary"
                    className="bg-brand-gold px-5 py-3 font-display text-xs font-bold uppercase tracking-[0.16em] text-brand-base transition-colors duration-150 hover:bg-[#E5B647]"
                >
                    {cta.label}
                </Link>
            </div>
        </div>
    </section>
);

export default CtaBand;
